var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "svg858",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs862"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " Outline / plus-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 15,11 h -2 c -2,0 0.496113,0.0015 -2,0 H 9 c -0.55,0 -1,0.45 -1,1 0,0.55 0.45,1 1,1 h 2 c 2.620056,-0.0022 -0.368503,-0.0055 2,0 h 2 c 0.55,0 1,-0.45 1,-1 0,-0.55 -0.45,-1 -1,-1 z m -3,9 C 7.589,20 4,16.411 4,12 4,7.589 7.589,4 12,4 c 4.411,0 8,3.589 8,8 0,4.411 -3.589,8 -8,8 z M 12,2 C 6.486,2 2,6.486 2,12 2,17.514 6.486,22 12,22 17.514,22 22,17.514 22,12 22,6.486 17.514,2 12,2 Z",
    fill: "#979797"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/minus_circle.2f25b893e6483e73ff879194d6537169.svg";
export { ForwardRef as ReactComponent };